import { render, staticRenderFns } from "./ResetSuccess.vue?vue&type=template&id=eee56596&scoped=true"
import script from "./ResetSuccess.vue?vue&type=script&lang=js"
export * from "./ResetSuccess.vue?vue&type=script&lang=js"
import style0 from "./ResetSuccess.vue?vue&type=style&index=0&id=eee56596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee56596",
  null
  
)

export default component.exports